export const USER_ROLE_SET = [
  {
    "role": "ROLE_ADMIN",
    "name": "Admin",
    "maxDateRange": "4",
    "unit": "Y"
  },
  {
    "role": "ROLE_USER",
    "name": "PREMIUM",
    "maxDateRange": "3",
    "unit": "Y"
  },
  {
    "role": "ROLE_USER_01",
    "name": "PREMIUM",
    "maxDateRange": "3",
    "unit": "Y"
  },
  {
    "role": "ROLE_USER_02",
    "name": "GOLD",
    "maxDateRange": "1",
    "unit": "Y"
  },
  {
    "role": "ROLE_USER_03",
    "name": "LIGHT",
    "maxDateRange": "3",
    "unit": "M"
  },
  {
    "role": "ROLE_USER_04",
    "name": "TEST",
    "maxDateRange": "1",
    "unit": "W"
  },
]